import axios from "axios";
import { getSongbirdApiBase } from "./songbird-client";
import { fetchNewsFeedLatestNews } from "./news-feed-client";

export function resolveSongbirdApiBase(config) {
	return getSongbirdApiBase(config);
}

export function mapStocksNewsItem(item) {
	let imageUrl =
		item.image || item.featured_image || "/images/placeholder-news.jpg";

	if (typeof imageUrl === "string" && imageUrl.startsWith("http")) {
		try {
			const url = new URL(imageUrl);
			imageUrl = url.pathname + url.search;
		} catch {
			imageUrl = "/images/placeholder-news.jpg";
		}
	}

	if (imageUrl === false) {
		imageUrl = "/images/placeholder-news.jpg";
	}

	const stock_pairs =
		item.stock_pairs && item.stock_pairs.length > 0 ? item.stock_pairs : [];

	return {
		date: item.date || new Date().toISOString(),
		title:
			typeof item.title === "string"
				? item.title
				: item.title?.rendered || "",
		content_read_time: item.content_read_time || 5,
		slug: item.slug?.replace(/^\/+|\/+$/g, "") || "",
		image: imageUrl,
		stock_pairs,
		stock: stock_pairs[1] || null
	};
}

export function toHomepageNewsCard(item) {
	return {
		...item,
		slug: `/news/${item.slug}/`
	};
}

/** Fixed limit served by the flattened `news-feed/latest-news` endpoint. */
const LATEST_NEWS_FEED_LIMIT = 20;

export async function fetchStocksNewsList({
	config,
	limit = 20,
	timeout = 25000
} = {}) {
	// Prefer the flattened, pagination-free bundle when the caller wants the
	// same fixed first page the /news page and homepage always request.
	// Falls back to the original paginated endpoint for any other limit, or
	// if the bundled fetch fails.
	if (limit === LATEST_NEWS_FEED_LIMIT) {
		const bundle = await fetchNewsFeedLatestNews({ config, timeout }).catch(
			(err) => {
				console.warn(
					"[stocks-news] news-feed/latest-news bundled fetch failed, falling back:",
					err?.message || err
				);
				return null;
			}
		);

		if (bundle?.items?.length) {
			return bundle.items.map(mapStocksNewsItem);
		}
	}

	const songbirdBase = resolveSongbirdApiBase(config);
	const current_hostname = config.public.current_hostname;

	const response = await axios.get(`${songbirdBase}stocks/news`, {
		params: { limit },
		headers: { "X-Original-Origin": current_hostname },
		timeout
	});

	const items = response.data?.items || [];
	return items.map(mapStocksNewsItem);
}
